import { TM_COMMON_CONSTANTS } from '../pages/constants/tmCommonConstants';
import { TmCommonModules } from './apiModules/TmCommonModules';

export class NetworkLayer {
  constructor() {
    const { BASE_URL, HTTP_HEADERS, PREVENTION_COMMON } = TM_COMMON_CONSTANTS;
    this.tmCommonModules = new TmCommonModules(
      BASE_URL,
      HTTP_HEADERS,
      PREVENTION_COMMON
    );
  }

  tmCommonTransactionHistoryAPI = async (payload) =>
    await this.tmCommonModules.fetchTMCommonTransactionHistoryAPI(payload);

  tmCommonDownloadTransactionHistoryAPI = async (payload) =>
    await this.tmCommonModules.downloadTMCommonTransactionHistoryAPI(payload);

  tmCommonTransactionTriggeredTypologiesAPI = async (payload) =>
    await this.tmCommonModules.fetchTMCommonTransactionTriggeredTypologiesAPI(
      payload
    );

  tmCommonScoreExplainabilityAPI = async (payload) =>
    await this.tmCommonModules.fetchTMCommonScoreExplainablity(payload);

  preventionCommonScoreExplainabilityAPI = async (payload) =>
    await this.tmCommonModules.fetchPreventionCommonScoreExplainablity(payload);

  tmCommonPeerAndProfileGraphAPI = async (payload) =>
    await this.tmCommonModules.fetchTMCommonPeerAndProfileGraph(payload);

  tmCommonTypologyListAPI = async (payload) =>
    await this.tmCommonModules.fetchTypologyList(payload);

  tmCommonVariantsListForAlertIdAPI = async (payload) =>
    await this.tmCommonModules.fetchVariantsListForAlertId(payload);

  tmCommonRiskIndicatorListAPI = async (payload) =>
    await this.tmCommonModules.fetchRiskIndicatorList(payload);

  amlsTMCommonCustomerLoanDetailsAPI = async (payload) =>
    await this.tmCommonModules.fetchTMCommonCustomerLoanDetails(payload);

  tmCommonTransactionTypesFilterAPI = async (payload) =>
    await this.tmCommonModules.fetchTransactionTypesFilterAPI(payload);
}
